import client from './client';

export interface MyPhoto {
  _id: string;
  thumbnailUrl: string | null;
  originalUrl: string | null;
  processedUrl?: string | null;
  originalFilename: string;
  albumId: string;
  albumName: string;
  uploadedAt: string;
}

export interface MyPhotosPage {
  photos: MyPhoto[];
  nextCursor: string | null;
  hasMore: boolean;
  lastRefreshedAt: string | null;
  albumTotalCounts: Record<string, number>;
  albumNames: Record<string, string>;
  unscannedMembershipsCount: number;
}

export interface MyAlbumPhotosPage {
  photos: MyPhoto[];
  nextCursor: string | null;
  hasMore: boolean;
}

export const meApi = {
  getMyPhotos: (cursor?: string, limit = 24) =>
    client
      .get<MyPhotosPage>('/me/photos', {
        params: { ...(cursor ? { cursor } : {}), limit },
      })
      .then((r) => r.data),

  /** Photos matched for the current user within a single album (paginated). */
  getMyAlbumPhotos: (albumId: string, cursor?: string, limit = 24) =>
    client
      .get<MyAlbumPhotosPage>('/me/photos', {
        params: { albumId, ...(cursor ? { cursor } : {}), limit },
      })
      .then((r) => r.data),

  refreshMyPhotos: () =>
    client
      .post<{ refreshed: number; totalMatches: number }>('/me/photos/refresh')
      .then((r) => r.data),
};
